import React from "react";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { values } from 'lodash'

export const fontAwesome = {
    /**
     * 圖示清單
     */
    icons: values(fas),
    /**
   * 取得 FontAwesome Icon 元件
   * @param {string} iconName - icon 類型
   * @returns
   */
    getIconComponent: (iconName) => (props) => <FontAwesomeIcon icon={iconName} {...props} />
}
